import Typography from 'component/commonComponents/Typography/Typography';
import Box from 'component/layoutComponents/Box/Box';
import React, { useRef, useState } from 'react';
import { StyledCategoryList, StyledItem, ArrowButton, StyledSlider, StyledDot, StyledDots } from './categoryList.style';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import { Grid, Stack } from '@mui/material';
import { Slider, Settings } from "component/commonComponents/Slider";

export interface Category {
  id: string;
  name: string;
  image: string;
  children: Category[];
  lang_overrides?: any;
}

export interface CategoryListProps {
  label: string;
  categories: Category[];
  onItemClick?: (item: Category) => void;
  languageCode: string;
  slide?: any
}

const ITEMS_PER_SLIDE = {
  CARD: 5,
};

const CategoryList = (props: CategoryListProps) => {
  const { label, categories = [], onItemClick, languageCode } = props;
  const sliderRef = useRef<typeof Slider>(null);
  const sliderSettings: Settings = {
    speed: 300,
    dots: true,
    infinite: false,
    arrows: false,
    slidesToShow: 1,
    slidesPerRow: ITEMS_PER_SLIDE.CARD,
    beforeChange: (current: any, next: any) => setSlideIndex(next),
    customPaging: (i) => {
      return (<StyledDot aria-label={`item-${i}`} tabIndex={0}>•</StyledDot>)
    },
    appendDots: (dots: any) => {
      return (
        <StyledDots>
            {dots}
        </StyledDots>
      );
    },
    onInit: ()=>{
      if (sliderRef.current?.innerSlider?.list) {
        const slides = sliderRef.current.innerSlider.list.querySelectorAll('.slick-slide');
        const divInSlide = sliderRef.current.innerSlider.list.querySelectorAll('.slick-slide .MuiBox-root');        
        slides.forEach((slide:any) => {
          slide.setAttribute('tabindex', '0');
          slide.removeAttribute('aria-hidden')
        });
        divInSlide.forEach((item:any) =>{
          item.setAttribute('tabindex', '0');
        });
      }
    },
    onReInit: ()=>{
      if (sliderRef.current?.innerSlider?.list) {
        const slides = sliderRef.current.innerSlider.list.querySelectorAll('.slick-slide');
        const divInSlide = sliderRef.current.innerSlider.list.querySelectorAll('.slick-slide .cate-item');        
        slides.forEach((slide:any) => {
          slide.setAttribute('tabindex', '0');
          slide.removeAttribute('aria-hidden')
        });
        divInSlide.forEach((item:any) =>{
          item.setAttribute('tabindex', '0');
        });
      }
    },
    accessibility: true,
  };
  const [slideIndex, setSlideIndex] = useState(0);
  const listCate = categories.map((category, index) => {
    const overrideLang = category?.lang_overrides;
    let itemName = (overrideLang?.[languageCode]?.name || overrideLang?.[languageCode]) || category?.name;
    return (
      <StyledItem key={index} onClick={() => onItemClick?.(category)} className="cate-item">
        <Box height="85px">
          <img src={category.image} alt={itemName} title={itemName} />
        </Box>
        <Typography>{itemName}</Typography>
      </StyledItem>
    )
  });
  return (
    <StyledCategoryList>
      <Grid display="flex">
        <Typography kind="h6" fontSize="20px" fontWeight={600}>
          {label}
        </Typography>
        {Math.ceil(categories.length / ITEMS_PER_SLIDE.CARD) > 1 &&
          <Stack direction="row" gap="8px" alignItems="center" ml="auto">
            <ArrowButton
              disabled={slideIndex === 0}
              onClick={() => sliderRef.current?.slickPrev()}
              aria-label="Category Type Previous Button"
            >
              <ChevronLeft />
            </ArrowButton>

            <ArrowButton
              disabled={slideIndex === Math.ceil(categories.length / ITEMS_PER_SLIDE.CARD) - 1}
              onClick={() => sliderRef.current?.slickNext()}
              aria-label="Category Type Next Button"
            >
              <ChevronRight />
            </ArrowButton>
          </Stack>
        }

      </Grid>

      <StyledSlider
        ref={sliderRef}
        {...sliderSettings}
      >
        {listCate}
      </StyledSlider>
    </StyledCategoryList>
  );
};

export default CategoryList;
